<template>
  <div class="platform-announcement fill-page-container">
    <a-spin :spinning="loading">
      <div class="search-line">
        <a-form-model
          ref="searchForm"
          :model="searchForm"
          :label-col="{ span: 8 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-row>
            <a-col :span="6">
              <a-form-model-item label="内容标题" class="form-item">
                <a-input
                  v-model="searchForm.title"
                  placeholder="请输入内容标题"
                  style="width: 100%"
                  allow-clear
                />
              </a-form-model-item>
            </a-col>

            <a-col :span="6">
              <a-form-model-item label="发布时间" class="form-item">
                <a-range-picker
                  v-model="searchForm.lastUpdateDate"
                  style="width: 100%"
                  :show-time="{ format: 'HH:mm:ss' }"
                  format="YYYY-MM-DD HH:mm:ss"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  allow-clear
                />
              </a-form-model-item>
            </a-col>

            <a-col :span="12">
              <a-form-model-item class="form-item operation-item" :wrapper-col="{ span: 24 }">
                <a-button @click="handleReset">重置</a-button>
                <a-button style="margin-left: 8px" type="primary" @click="handleSearch">查询</a-button>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>

      <div class="announcement-list">
        <vxe-grid
          ref="xGrid"
          v-bind="gridOptions"
          :data="tableData"
          @page-change="handlePageChange"
        >
          <template #operate="{ row }">
            <a-button type="link" size="small" @click="viewDetail(row)">
              查看
            </a-button>
          </template>
        </vxe-grid>
      </div>
    </a-spin>
  </div>
</template>

<script>
import { findCategoryInfoPage } from '@/api/news'

export default {
  name: 'PlatformAnnouncement',
  data() {
    return {
      loading: false,
      searchForm: {
        title: '',
        lastUpdateDate: [],
        plateformId: sessionStorage.getItem('plateformId')||this.$route.meta.plateformId,
        moduleId: sessionStorage.getItem('moduleId')||this.$route.meta.moduleId
      },
      tableData: [],
      gridOptions: {
        border: true,
        showOverflow: true,
        size: 'mini',
        minHeight: 440,
        height: '100%',
        maxHeight: '100%',
        loading: false,
        columnConfig: {
          resizable: true
        },
        pagerConfig: {
          pageSize: 20,
          pageSizes: [10, 20, 50, 100],
          total: 0,
          currentPage: 1,
          layouts: ['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']
        },
        columns: [
          { type: 'seq', width: 60, title: '序号' },
          { field: 'title', title: '内容标题', minWidth: 200, showOverflow: true },
          { field: 'createBy', title: '发布人', width: 100 },
          { field: 'lastUpdateDate', title: '发布时间', width: 160 },
          { field: 'accessNum', title: '访问量', width: 100 },
          { title: '操作', width: 100, fixed: 'right', slots: { default: 'operate' }}
        ]
      }
    }
  },
  mounted() {
    console.log(this.$route,'this.$route')
    this.loadData()
  },
  methods: {
    async handlePageChange({ currentPage, pageSize }) {
      this.gridOptions.pagerConfig.currentPage = currentPage
      this.gridOptions.pagerConfig.pageSize = pageSize
      await this.loadData()
    },
    async loadData() {
      this.gridOptions.loading = true
      try {
        const params = {
          ...this.searchForm,
          pageSize: this.gridOptions.pagerConfig.pageSize,
          pageNo: this.gridOptions.pagerConfig.currentPage,
         
        }
        const res = await findCategoryInfoPage(params)
        if (res.head.cost === 0) {
          if(!res.body){
            this.tableData=[]
            this.gridOptions.pagerConfig.total=0
            return
          }
          this.tableData = res.body.data || []
          this.gridOptions.pagerConfig.total = res.body.totalRow || 0
        } else {
          this.$message.error(res.head.message || '加载数据失败')
        }
      } catch (error) {
        console.error(error)
        this.$message.error('加载数据失败')
      } finally {
        this.gridOptions.loading = false
      }
    },
    handleSearch() {
      this.gridOptions.pagerConfig.currentPage = 1
      this.loadData()
    },
    handleReset() {
      this.searchForm = {
        title: '',
        lastUpdateDate: [],
        plateformId: sessionStorage.getItem('plateformId')||this.$route.meta.plateformId,
        moduleId: sessionStorage.getItem('moduleId')||this.$route.meta.moduleId
      }
      this.handleSearch()
    },
    viewDetail(row) {
      // if (row.notifyType == 2) {
      //   this.$router.push({
      //     path: 'videoDetail',
      //     query: {
      //       id: row.id
      //     }
      //   })
      // } else {
      //   this.$router.push({
      //     path: 'newsPage' ,
      //     query: {
      //       id: row.id
      //     }
      //   })
      // }
      if(row.notifyType == 2){
        return
      }
      this.$router.push({
          path: 'newsPage' ,
          query: {
            id: row.id
          }
        })
    }
  }
}
</script>

<style lang="less" scoped>
.platform-announcement {
  background: #fff;
  padding: 8px 24px 0;
  .search-line {
    background: #fff;
    margin-bottom: 8px;
    border-radius: 4px;
    padding: 16px 0 8px;
    .form-item {
      margin-bottom: 8px;
      width: 100%;
      :deep(.ant-form-item-label) {
        min-width: 80px;
      }
      :deep(.ant-form-item-control-wrapper) {
        max-width: calc(100% - 80px);
      }
      &.operation-item {
        :deep(.ant-form-item-control) {
          text-align: right;
        }
        :deep(.ant-form-item-control-wrapper) {
          max-width: 100%;
        }
      }
    }
  }
  .announcement-list {
    height: calc(100vh - 137px);
    padding-bottom: 20px;
  }

}
</style>
